import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CustomizeHttpUrlGenerator} from "../../../../store/core/url/customizeHttpUrlGenerator";
import {AbstractActionService} from "../../../core/service/v2/service/action/abstractAction.service";
import {SaleDeleteProductActionPayload} from "./payload/action/saleDeleteProductAction.payload";

@Injectable()
export class SaleDeleteProductActionService extends AbstractActionService<SaleDeleteProductActionPayload, any> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('Sale', 'delete-product', customizeHttpUrlGenerator, httpClient);
    }
}